import React from 'react';
import styled from 'styled-components';
// import { IframeContainer, TermsAndConditionsFrame } from '../../../styles';

const IframeContainer = styled.div`
    width: 100%;
    height: 100%;
    margin: auto;
`;

const TermsAndConditionsFrame = styled.iframe`
    width: 100%;
    height: 100%;
    margin: auto;
    border: none;
`;

export class TermsAndConditionsIFrame extends React.Component {

    render() {
        return(
            <IframeContainer>
                <TermsAndConditionsFrame src={this.props.link} />
            </IframeContainer>
        );
    };
}
